/**
 * 书写规则：
 * 基于axios二次封装，接口和方法写一起，页面只需要传入参数即可；
 * 方法名：get请求：getName,post请求：postName；
 */
/**
 * 消息中心
 */

import { HTTP_MESSAGE,HTTP_ALB } from '../axios';

//  无鉴权消息列表接口
export const postMsgList = (params) => {
  return HTTP_MESSAGE.post('/noauth/msg/list', params);
}


//  公告接口
export const postHomeNotice = (params) => {
  return HTTP_ALB.get('/home/home/notice', params);
}

//  阅读公告（一键已读）
export const postHomeReadnotice= (params) => {
  return HTTP_ALB.post('/home/home/readnotice', params);
}

//  无鉴权消息阅读
export const postMsgRed= (params) => {
  return HTTP_MESSAGE.post('/noauth/msg/read', params);
}

